import { useNavigate } from "react-router-dom";
import {
  getSelectedTabListView,
  getUserData,
  setSelectedTabListView,
} from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useRef, useState } from "react";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../../../ButtonLink";
import AdminMenu from "../../AdminMenu";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import StoreFilterModal from "../../StoreFilterModal";
import { getRackModel } from "../../../services/RackModel/RackModel";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";

const { innerHeight: height } = window;

const RackModelAdmin = () => {
  const navigate = useNavigate();

  const { userProfileRole, brandProfileData } = getUserData();

  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [rackModelList, setRackModelList] = useState({});
  const [selectedStore, setSelectedStore] = useState(""); // Default to show all orders

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [storeFilterModalVisible, setStoreFilterModalVisible] = useState(false)

  const [brandStoreData, setBrandStoreData] = useState([]);



  const fetchRackModel = (storeId) => {
    setLoading(true);
    getRackModel(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setRackModelList(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  // for all status and one week data or by default data;





  const fetchBrandStoreInfo = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const getBrandStore = Res.map((item, index) => ({
            name: item.storeName,
            value: item.id,
          }));
          setBrandStoreData(getBrandStore);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchBrandStoreInfo();
  }, []);

  useEffect(() => {
    if (selectedStore > 0) {
      fetchRackModel(selectedStore);
    }
  }, [selectedStore]);

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Rack Model
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <Dropdown
              value={selectedStore}
              options={brandStoreData}
              optionLabel="name"
              onChange={(e) => {
                setSelectedStore(e.target.value);
              }}
              placeholder="Select a Store"
              style={{ width: '100%' }}
            />

            <label
              htmlFor="storeSelection"
              className="text-md"
              style={{ color: "blue" }}
            >
              Store Selection <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="  my-2">


        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : rackModelList ? (
          <div>
            <div className="flex-1 ">
              <div className="m-4 shadow-4">
                <div className="flex flex-1">
                  <div
                    className="flex-1 px-3 py-1"
                    style={{
                      backgroundColor: "#F8FFEE",
                    }}
                  >
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Rack Id :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {rackModelList.rackId}
                    </p>
                  </div>
                  <div
                    className="flex-1 px-3 py-1"
                    style={{
                      backgroundColor: "#E2F4F8",
                    }}
                  >
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Rack Prefix :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {rackModelList.rackPrefix}
                    </p>
                  </div>
                  <div
                    className="flex-1 px-3 py-1 flex justify-content-between"
                    style={{
                      backgroundColor: "#F8FFEE",
                    }}
                  >
                    <div>
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Status :
                      </p>
                      <p className="text-lg font-medium capitalize">
                        {rackModelList.status ? "ACTIVE" : "INACTIVE"}
                      </p>
                    </div>

                  </div>
                </div>
                <div className="flex flex-1">
                  <div
                    className="flex-1 px-3 py-1 flex justify-content-between"
                    style={{
                      backgroundColor: "#E2F4F8",
                    }}
                  >
                    <div>
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Rack Limit :
                      </p>
                      <p className="text-lg font-medium capitalize">
                        {rackModelList.rackLimit}
                      </p>
                    </div>

                  </div>
                  <div
                    className=" px-3 py-1"
                    style={{
                      flex: 1,
                      backgroundColor: "#F8FFEE",
                    }}
                  >
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Rack Type:
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {rackModelList.rackType}
                    </p>
                  </div>
                  <div
                    className=" px-3 py-1"
                    style={{
                      flex: 1,
                      backgroundColor: "#E2F4F8",
                    }}

                  > <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                      Assignment Type:
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {rackModelList.assignmentType}
                    </p>

                  </div>
                </div>
                  <div className="flex flex-1">
                    <div
                      className="flex-1 px-3 py-1"
                      style={{
                        backgroundColor: "#F8FFEE",
                      }}
                    >
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Last Reset Date :
                      </p>
                      <p className="text-lg font-medium capitalize">
                        {rackModelList.lastResetDate}
                      </p>
                    </div>
                    <div
                      className="flex-1 px-3 py-1"
                      style={{
                        backgroundColor: "#E2F4F8",
                      }}
                    >
                       
                    </div>
                    <div
                      className="flex-1 px-3 py-1 flex justify-content-between"
                      style={{
                        backgroundColor: "#F8FFEE",
                      }}
                    >
                      <div>
                        
                      </div>

                    </div>
                  </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Rack Found</p>
          </div>
        )}

        <AdminMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default RackModelAdmin;
